import { render, staticRenderFns } from "./feederbowlPicker.vue?vue&type=template&id=4f4de95e&scoped=true&"
import script from "./feederbowlPicker.vue?vue&type=script&lang=js&"
export * from "./feederbowlPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4de95e",
  null
  
)

export default component.exports